import React from 'react'
import { PageSchema } from './usePageSchema'

// Legacy ServiceSchema - now uses the universal system
const ServiceSchema = ({ title, url, description, provider = "Ishan Tech", areaServed = "India" }) => {
    // If props are provided, use custom schema
    // if (title && url) {
    //     const schema = {
    //         "@context": "https://schema.org",
    //         "@type": "Service",
    //         "name": title,
    //         "url": url,
    //         "description": description,
    //         "provider": {
    //             "@type": "Organization",
    //             "name": provider,
    //             "url": "https://ishantechnologies.com"
    //         },
    //         "areaServed": areaServed,
    //         "serviceType": "Cloud Services"
    //     }
    //     return (
    //         <script 
    //             type="application/ld+json"
    //             dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    //         />
    //     )
    // }
    
    // Otherwise use automatic page schema
    return <PageSchema />
}

export default ServiceSchema